var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgEditor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2396 1848",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      filter: "drop-shadow(rgba(0, 0, 0, 0.25) 7px 23px 15px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bottompanel"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M2396 1447.31H0V1171H2396V1447.31Z",
    fill: "#E8EDEE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "stand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "topstand",
    d: "M1019 1447H1382.5L1471 1689H926L1019 1447Z",
    fill: "#B0B6BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottomstand",
    d: "M761 1848C761 1760.19 832.187 1689 920 1689H1477C1564.81 1689 1636 1760.19 1636 1848V1848H761V1848Z",
    fill: "#E8EDEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "animatorscreen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "display",
    d: "M0 100C0 44.7716 44.7715 0 100 0H2296C2351.23 0 2396 44.7715 2396 100V1171H0V100Z",
    fill: "#38454F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgimage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M1781 52V614.8H615V52H1781Z",
    fill: "#EBF2F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M1725.66 205.6V614.8H615V309.2H656.505V328.2H690.526V317.2H722.278V273.6H737.928V253.2H740.423V273.6H778.072V235.4H781.701V273.6H806.876V273H806.649V268.2H806.876V263.6H806.649V255.8H806.876V251H806.649V243.4H806.876V238.6H806.649V230.8H806.876V225.6H806.649V218H806.876V211.2H806.649V203.6H806.876V198.6H814.134V192.8H815.495V198.6H870.608V192.8H871.742V198.6H881.722V238.6H888.979H888.753V230.8H888.979V225.6H888.753V218H888.979V212.8H888.753V205.2H888.979V205H955.66V205.2H967.227C967.832 205.333 968.437 205.467 969.041 205.6V249.2H1017.8V306.6H1057.27V200.6H1065.89V193.2H1067.47V200.6H1098.77V193.2H1100.13V200.6H1144.36V193.2H1145.95V200.6H1173.62V193.2H1175.21V200.6H1186.77V299.4H1230.32V283.4L1281.8 283.6V257.8H1292.24V252.6H1293.6V257.8H1333.29H1341.23V252.6H1342.59V257.8H1352.11V309.2H1413.35V328.2H1447.6V317.2H1479.12V273.6H1494.77V253.2H1497.27V273.6H1534.92V235.4H1538.77V273.6H1563.72V273V268.2V263.6V255.8V251V243.4V238.6V230.8V225.6V218V211.2V203.6V198.6H1571.21V192.8H1572.34V198.6H1627.45V192.8H1628.59V198.6H1638.79V238.6H1645.6H1645.82V230.8V225.6V218V212.8V205.2V205H1712.73V205.2H1724.07C1724.68 205.333 1725.21 205.467 1725.66 205.6V205.6Z",
    fill: "#D5E5FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M1186.77 217.4H1088.11V200.6H1186.77V217.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M1609.76 208.8H1563.72V198.6H1609.76V208.8Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M1609.76 224.4H1563.72V214.2H1609.76V224.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M1609.76 240.4H1563.72V230.2H1609.76V240.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M1609.76 256.6H1563.72V246.4H1609.76V256.6Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M1609.76 272.2H1563.72V262.2H1609.76V272.2Z",
    fill: "#E2EEFD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_10",
    d: "M1609.76 289.6H1563.72V279.4H1609.76V289.6Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_11",
    d: "M1609.76 305.2H1563.72V295H1609.76V305.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_12",
    d: "M1609.76 321.2H1563.72V311H1609.76V321.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_13",
    d: "M1609.76 337.4H1563.72V327.2H1609.76V337.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_14",
    d: "M1609.76 353H1563.72V342.8H1609.76V353Z",
    fill: "#E2EEFD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_15",
    d: "M855.639 208.8H806.423V198.6H855.639V208.8Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_16",
    d: "M855.639 224.4H806.423V214.2H855.639V224.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_17",
    d: "M855.639 240.4H806.423V230.2H855.639V240.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_18",
    d: "M855.639 256.6H806.423V246.4H855.639V256.6Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_19",
    d: "M855.639 272.2H806.423V262.2H855.639V272.2Z",
    fill: "#E2EEFD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_20",
    d: "M855.639 289.6H806.423V279.4H855.639V289.6Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_21",
    d: "M855.639 305.2H806.423V295H855.639V305.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_22",
    d: "M855.639 321.2H806.423V311H855.639V321.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_23",
    d: "M855.639 337.4H806.423V327.2H855.639V337.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_24",
    d: "M855.639 353H806.423V342.8H855.639V353Z",
    fill: "#E2EEFD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_25",
    d: "M945.907 215.4H889.887V205.2H945.907V215.4Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_26",
    d: "M945.907 231H889.887V221H945.907V231Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_27",
    d: "M945.907 247H889.887V236.8H945.907V247Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_28",
    d: "M945.907 263.2H889.887V253.2H945.907V263.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_29",
    d: "M945.907 279H889.887V268.8H945.907V279Z",
    fill: "#E2EEFD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_30",
    d: "M945.907 295.2H889.887V285.2H945.907V295.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_31",
    d: "M945.907 311H889.887V300.8H945.907V311Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_32",
    d: "M945.907 327H889.887V316.8H945.907V327Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_33",
    d: "M945.907 343.2H889.887V333H945.907V343.2Z",
    fill: "#E2EEFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_34",
    d: "M945.907 358.8H889.887V348.6H945.907V358.8Z",
    fill: "#E2EEFD"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_35",
    d: "M1626.09 163.4H1621.78V163L1623.14 152.8C1623.14 152.6 1623.37 152.4 1623.82 152.4C1623.82 152.4 1623.9 152.4 1624.05 152.4C1624.2 152.4 1624.43 152.467 1624.73 152.6C1624.88 152.733 1624.96 152.933 1624.96 153.2L1626.09 163.4Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_36",
    d: "M1622.24 161H1622.01L1623.14 152.8C1623.14 152.6 1623.37 152.4 1623.82 152.4C1623.82 152.4 1623.9 152.4 1624.05 152.4C1624.35 152.533 1624.51 152.733 1624.51 153V159C1624.51 160.2 1623.37 161 1622.24 161V161Z",
    fill: "#AFCDFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_37",
    d: "M1628.81 208.8V534H1620.42V208.8H1628.81Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_38",
    d: "M1624.28 208.8V534H1620.42V208.8H1624.28Z",
    fill: "#AEC3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_39",
    d: "M1637.89 482V568.2H1611.35V482H1637.89Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_40",
    d: "M1627.23 482V568.2H1611.35V482H1627.23Z",
    fill: "#AEC3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_41",
    d: "M1639.25 168.2C1639.25 172.4 1632.44 175.6 1624.05 175.6C1623.3 175.6 1622.61 175.6 1622.01 175.6C1614.53 175 1608.63 172 1608.63 168.2C1608.63 164.6 1614.53 161.6 1622.01 161C1622.61 161 1623.3 161 1624.05 161C1632.44 161 1639.25 164.2 1639.25 168.2Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_42",
    d: "M1631.31 168.2C1631.31 171.6 1627.45 174.4 1622.01 175.6C1614.53 175 1608.63 172 1608.63 168.2C1608.63 164.6 1614.53 161.6 1622.01 161C1627.45 162.2 1631.31 165 1631.31 168.2Z",
    fill: "#AEC3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_43",
    d: "M1637.89 215.2H1611.35L1602.05 175.2H1645.82L1637.89 215.2Z",
    fill: "#AEC3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_44",
    d: "M1648.32 172.2V176.2H1599.56V172.2H1648.32Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_45",
    d: "M1630.18 172.2V176.2H1599.56V172.2H1630.18Z",
    fill: "#AEC3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_46",
    d: "M1618.84 475.6C1619.06 475 1619.97 474.4 1620.65 474.4H1628.81C1629.49 474.4 1629.95 474.8 1630.18 475.4L1632.67 482H1615.66L1618.84 475.6Z",
    fill: "#819DEA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_47",
    d: "M1605.23 177.2H1642.65L1635.39 213H1613.85L1605.23 177.2Z",
    fill: "#C5D7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_48",
    d: "M1645.14 172.2H1602.73L1606.13 168H1641.97L1645.14 172.2Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_49",
    d: "M1634.71 172.2H1602.73L1606.13 168H1631.31L1634.71 172.2Z",
    fill: "#AEC3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "greenbottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_50",
    d: "M883.309 568.6L615 568.4V510.6C615.907 511 616.815 511.4 617.722 511.8C654.237 528.2 649.474 550.2 694.835 542C740.196 534 777.392 530.8 797.804 542C817.99 553.4 832.959 549 858.134 548.8C879 548.8 882.629 563.6 883.309 568.6Z",
    fill: "#A8D29F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_51",
    d: "M938.876 502.4H683.268L671.474 449.4H926.629L938.876 502.4Z",
    fill: "#D36D1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_52",
    d: "M943.412 502.4H687.804L676.01 449.4H931.165L943.412 502.4Z",
    fill: "#F49540"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_53",
    d: "M758.794 508.8H688.938C685.99 508.8 683.268 506.6 683.268 504V502.4H758.794V508.8Z",
    fill: "#D36D1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_54",
    d: "M990.361 508.8H758.34V502.4H990.361V508.8Z",
    fill: "#FFA255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_55",
    d: "M698.691 508.8L694.155 524L681.227 569C681.227 569.6 680.547 570 679.866 570C678.506 570 677.598 569 677.825 567.8L689.392 515.4L690.753 508.8H698.691Z",
    fill: "#FFA255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_56",
    d: "M694.155 524C694.608 516.2 689.392 515.4 689.392 515.4L690.753 508.8H698.691L694.155 524Z",
    fill: "#D36D1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_57",
    d: "M754.031 508.8L749.722 524L736.794 569C736.567 569.6 735.887 570 735.206 570C734.072 570 732.939 569 733.165 567.8L744.732 515.4L746.32 508.8H754.031Z",
    fill: "#FFA255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_58",
    d: "M749.722 524C750.175 516.2 744.732 515.4 744.732 515.4L746.32 508.8H754.031L749.722 524Z",
    fill: "#D36D1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_59",
    d: "M976.979 508.8L978.567 515.4L990.134 567.8C990.361 569 989.227 570 988.093 570C987.412 570 986.732 569.6 986.505 569L973.577 524L969.268 508.8H976.979Z",
    fill: "#FFA255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_60",
    d: "M969.268 508.8H976.979L978.567 515.4C978.567 515.4 973.124 516.2 973.577 524L969.268 508.8Z",
    fill: "#D36D1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_61",
    d: "M921.639 508.8L923 515.4L934.567 567.8C934.794 569 933.887 570 932.526 570C931.845 570 931.165 569.6 931.165 569L918.237 524L913.701 508.8H921.639Z",
    fill: "#FFA255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_62",
    d: "M913.701 508.8H921.639L923 515.4C923 515.4 917.784 516.2 918.237 524L913.701 508.8Z",
    fill: "#D36D1A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "greentop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_63",
    d: "M774.443 197C767.866 200.4 760.155 202.6 751.536 203C714.567 205 701.866 217.2 671.928 242.8C655.825 256.6 633.598 259.6 615 260.2V85.6001C620.216 88.8001 625.66 92.2001 631.103 95.4001C651.516 107.4 673.515 117.2 697.783 112C722.052 106.8 740.876 107.2 755.392 111.4C774.217 116.6 786.464 127.8 795.309 141.8C807.33 160.8 796.897 185.6 774.443 197V197Z",
    fill: "#A8D29F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_64",
    d: "M1076.77 135.4C1076.77 127.2 1084.03 120.6 1093.33 120.6C1102.4 120.6 1109.89 127.2 1109.89 135.4C1109.89 143.4 1102.4 150 1093.33 150C1084.03 150 1076.77 143.4 1076.77 135.4Z",
    fill: "#F8FCFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_65",
    d: "M1349.62 122.2C1349.62 122.2 1364.13 101.8 1398.61 104.2C1398.61 104.2 1448.51 70 1502.03 99.6C1502.03 99.6 1558.73 92.2 1600.69 106C1628.59 115 1637.89 124.6 1637.89 124.6L1349.62 122.2Z",
    fill: "#F8FCFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cyclesvg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_66",
    d: "M1349.62 554C1349.62 554 1343.95 535.6 1359.6 517.8C1375.25 500 1401.56 504.8 1401.56 504.8C1401.56 504.8 1405.19 509.8 1397.93 513.8C1390.67 517.8 1365.27 509.8 1358.92 548.8C1358.92 548.8 1355.74 556.8 1349.62 554V554Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_67",
    d: "M1152.07 290.8C1152.07 286.4 1156.15 282.6 1161.37 282.6C1166.59 282.6 1170.9 286.4 1170.9 290.8C1170.9 295.4 1166.59 299.2 1161.37 299.2C1156.15 299.2 1152.07 295.4 1152.07 290.8Z",
    fill: "#ED7D2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_68",
    d: "M1114.88 505.6L1106.94 504.6L1138.92 298.6L1147.08 299.6L1114.88 505.6Z",
    fill: "#131375"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_69",
    d: "M1119.41 305.6V297.8L1160.46 289.8L1163.19 296.4L1119.41 305.6Z",
    fill: "#ED7D2B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_70",
    d: "M1352.11 557H1165.68C1162.28 557 1159.56 554.6 1159.56 551.6V549C1159.56 546 1162.28 543.6 1165.68 543.6H1352.11C1355.51 543.6 1358.24 546 1358.24 549V551.6C1358.24 554.6 1355.51 557 1352.11 557Z",
    fill: "#131375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_71",
    d: "M1121.91 436.4L1199.02 544H1182.69L1118.5 453.2L1121.91 436.4Z",
    fill: "#131375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "backtire"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_72",
    d: "M1390.23 554.508C1383.53 551.948 1380.16 544.425 1382.72 537.724C1385.28 531.024 1392.81 527.66 1399.51 530.22C1406.21 532.78 1409.57 540.304 1407.01 547.004C1404.45 553.704 1396.93 557.068 1390.23 554.508Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1402.26 569.171C1387.9 574.072 1372.36 566.443 1367.46 552.075C1362.63 537.921 1370.19 522.175 1384.56 517.274C1398.93 512.372 1414.53 520.216 1419.36 534.37C1424.26 548.738 1416.63 564.269 1402.26 569.171ZM1386.53 523.064C1375.38 526.868 1369.23 539.021 1373.04 550.172C1376.84 561.324 1389.21 567.399 1400.36 563.595C1411.51 559.791 1417.37 547.497 1413.57 536.345C1409.77 525.194 1397.69 519.259 1386.53 523.064Z",
    fill: "#060633"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_73",
    d: "M1388.53 534.296C1392.2 537.767 1397.48 538.751 1402.59 537.344L1413.63 534.071L1414.24 538.178L1402.82 541.305C1398.09 542.858 1393.82 546.648 1391.45 551.687L1385.68 563.946L1382.54 562.488L1388.12 550.156C1390.23 545.793 1389.31 540.793 1386.22 538.063L1376.76 529.799L1379.36 526.403L1388.53 534.296Z",
    fill: "#060633"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_74",
    d: "M1355.07 556.602C1353.7 556.602 1352.57 556.002 1352.12 554.802C1351.66 553.402 1352.57 551.802 1354.16 551.402L1392.49 540.202C1394.08 539.602 1395.66 540.402 1396.34 541.802C1396.8 543.202 1395.89 544.802 1394.3 545.202L1355.97 556.402C1355.67 556.535 1355.37 556.602 1355.07 556.602Z",
    fill: "#131375"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_75",
    d: "M1393.36 540.084C1394.64 539.5 1396.29 540.237 1396.96 541.68C1397.71 543.329 1397.19 545.066 1395.92 545.65C1394.64 546.234 1392.99 545.498 1392.23 543.848C1391.57 542.405 1392.09 540.668 1393.36 540.084Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fronttire"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_76",
    d: "M1097.94 520.5C1107.4 514.855 1119.72 517.965 1125.37 527.419C1131.01 536.874 1127.9 549.199 1118.45 554.844C1108.99 560.489 1096.67 557.38 1091.02 547.926C1085.38 538.471 1088.49 526.145 1097.94 520.5Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1072.01 549.873C1064.27 530.829 1073.59 508.753 1092.63 501.013C1111.68 493.273 1133.75 502.589 1141.49 521.634C1149.23 540.678 1139.92 562.753 1120.87 570.494C1101.83 578.234 1079.75 568.917 1072.01 549.873ZM1134.38 524.526C1128.17 509.248 1110.8 501.919 1095.53 508.129C1080.25 514.338 1072.92 531.704 1079.13 546.981C1085.34 562.258 1102.7 569.588 1117.98 563.378C1133.26 557.169 1140.59 539.803 1134.38 524.526Z",
    fill: "#060633"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_77",
    d: "M1121.04 537.27C1113.41 538.922 1107.29 543.894 1104.07 551.367L1097.33 567.01L1092.25 563.967L1099.1 547.729C1102.04 540.953 1101.75 532.671 1098.08 525.353L1089.17 507.694L1094.15 505.51L1102.95 522.974C1106.04 529.319 1112.73 532.721 1118.76 531.5L1137.18 527.632L1138.83 533.516L1121.04 537.27Z",
    fill: "#060633"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_78",
    d: "M1108.56 541.218C1107.24 541.693 1105.65 540.819 1105.11 539.325C1104.5 537.618 1105.17 535.931 1106.48 535.457C1107.8 534.983 1109.39 535.856 1110.01 537.563C1110.54 539.057 1109.88 540.744 1108.56 541.218Z",
    fill: "#F99746"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_79",
    d: "M1084.48 499.8C1084.48 499.8 1101.95 489 1126.22 496C1150.48 503 1154.11 526.4 1154.11 526.4C1154.11 526.4 1150.03 531.2 1143.45 526.4C1136.65 521.8 1136.65 498 1092.88 505.6C1092.88 505.6 1083.35 505.8 1084.48 499.8V499.8Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_80",
    d: "M1277.27 126.2L1261.84 150.4L1231.23 172.8C1231.23 172.8 1221.47 159.4 1221.47 147.8C1221.47 136 1251.87 92.7998 1251.87 92.7998L1277.27 126.2Z",
    fill: "#829CE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_81",
    d: "M1275.91 156.2C1275.91 156.2 1265.7 172.4 1247.33 169.6C1247.33 169.6 1241.89 162.4 1240.53 156.6C1240.37 155.933 1240.22 155.267 1240.07 154.6C1238.48 148 1237.35 144.4 1237.35 144.4C1238.26 144 1261.39 130.6 1261.62 131.2C1265.02 149 1275.91 156.2 1275.91 156.2Z",
    fill: "#ED975D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_82",
    d: "M1231.68 111C1235.08 106.2 1240.75 101.2 1258.44 107.2C1276.36 113.2 1268.88 122.6 1263.21 138.2C1257.76 153.8 1229.41 145.4 1229.41 145.4C1222.15 143 1228.5 115.8 1231.68 111V111Z",
    fill: "#FFB27D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_83",
    d: "M1204.92 538.8C1212.17 537.8 1224.88 534 1227.82 525.8C1227.82 525.533 1227.9 525.267 1228.05 525C1230.32 516.2 1246.65 527.6 1246.65 527.6C1246.65 527.6 1246.65 527.933 1246.65 528.6C1247.1 531.8 1248.01 542.4 1244.83 543.8C1244.68 543.8 1244.38 543.867 1243.93 544H1197.43C1197.89 542.6 1199.25 539.6 1204.92 538.8V538.8Z",
    fill: "#A9453D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_84",
    d: "M1295.87 538.8C1303.12 537.8 1315.82 534 1318.77 525.8C1318.77 525.533 1318.85 525.267 1319 525C1321.27 516.2 1337.6 527.6 1337.6 527.6C1337.6 527.6 1337.67 527.933 1337.82 528.6C1338.05 531.8 1338.96 542.4 1336.01 543.8C1335.71 543.8 1335.33 543.867 1334.88 544H1288.38C1288.83 542.6 1290.2 539.6 1295.87 538.8V538.8Z",
    fill: "#A9453D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_85",
    d: "M1276.13 303.8C1276.13 303.8 1270.46 397 1266.83 441.4C1266.68 442.067 1266.61 442.8 1266.61 443.6C1262.75 487.2 1246.65 527.6 1246.65 527.6C1231 530.6 1227.82 525.8 1227.82 525.8C1227.82 525.8 1222.15 495.4 1221.47 477.4C1221.02 467 1216.26 412.2 1212.17 367.6C1209.23 334.8 1206.73 307.6 1206.73 307.6L1276.13 303.8Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_86",
    d: "M1276.13 303.8C1276.13 303.8 1270.46 397 1266.83 441.4C1266.68 442.067 1266.61 442.8 1266.61 443.6L1212.17 367.6C1209.23 334.8 1206.73 307.6 1206.73 307.6L1276.13 303.8Z",
    fill: "#ED7D2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_87",
    d: "M1289.51 293C1289.51 293 1299.95 310.6 1300.63 323.6C1301.08 336.6 1304.03 377.8 1310.15 391.2C1322.17 417 1337.6 527.6 1337.6 527.6C1336.01 531.8 1318.09 527.4 1318.09 527.4C1318.09 527.4 1307.43 506.8 1278.17 460.2C1248.69 413.8 1218.07 310.8 1218.07 310.8L1289.51 293Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_88",
    d: "M1204.24 259.2C1204.24 256.4 1204.31 253.6 1204.46 250.8C1204.46 250.266 1204.46 249.733 1204.46 249.2C1204.69 239.4 1224.42 183.6 1228.28 175.4C1230.09 171.4 1233.27 167.8 1233.27 167.8C1239.39 168.8 1245.74 168.4 1252.09 165.4C1258.9 162.4 1266.38 159 1267.52 159.8C1277.04 165.8 1287.25 192 1294.73 221.8C1302.9 254 1326.48 364 1326.48 365.8C1326.71 367.6 1264.79 375.6 1208.09 350.8C1207.41 350.6 1204.24 262.4 1204.24 259.2V259.2Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_89",
    d: "M1204.01 278.6C1204.01 277.8 1204.01 276.8 1204.24 276L1204.01 275.8C1204.01 273.4 1204.01 271.067 1204.01 268.8C1204.01 265.6 1204.09 262.4 1204.24 259.2L1256.17 218C1256.17 218 1261.62 281.4 1206.05 308.8C1206.05 305.4 1204.24 282.4 1204.01 278.6Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_90",
    d: "M1149.8 290C1147.08 285.8 1149.35 284 1149.35 284C1149.35 284 1195.16 254.2 1198.79 251.2C1202.42 248 1220.57 198.6 1220.57 198.6C1220.57 198.6 1226.92 178.6 1240.07 176.8C1251.64 175.2 1259.35 180.4 1264.11 186.4C1270.01 193.4 1270.46 203 1265.02 210.6C1253 227.2 1228.73 260.4 1221.7 266C1206.28 278.4 1156.38 293.4 1156.38 293.4C1156.38 293.4 1152.07 293.4 1149.8 290V290Z",
    fill: "#FFB27D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_91",
    d: "M1260.03 135.8C1261.16 134.2 1265.25 125.4 1259.35 126.8C1253.45 128.2 1253 126.4 1252.77 124.4C1252.77 122.4 1251.87 115.8 1247.33 114.2C1243.02 112.6 1228.96 119.2 1218.53 113C1218.53 113 1228.28 108.2 1232.13 101.8C1235.76 95.7999 1239.39 89.7999 1251.87 92.7999C1264.34 95.9999 1279.08 102.2 1282.71 108.6C1286.34 115.2 1284.3 122.2 1282.26 125.2C1268.2 145 1262.3 142.8 1261.84 142.4C1258.67 140.4 1260.03 135.8 1260.03 135.8V135.8Z",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_92",
    d: "M1304.48 126.2C1304.48 132.6 1275.91 167.8 1275.91 167.8C1263.43 174.8 1233.27 167.8 1233.27 167.8C1233.27 167.8 1268.42 136.4 1267.97 126.4C1267.29 116.4 1251.87 92.7998 1251.87 92.7998C1287.7 93.1998 1304.48 119.6 1304.48 126.2V126.2Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_93",
    d: "M1224.42 306.6C1224.42 306.6 1251.64 310.4 1268.88 308.2L1268.42 332.4L1246.65 339.8L1224.42 329V306.6Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_94",
    d: "M1157.06 293C1157.06 293 1152.53 295.2 1148.44 297.2C1144.36 299 1141.87 296 1135.51 294.6L1122.81 297C1117.6 296 1124.4 290.6 1128.03 287.6C1131.66 284.8 1149.12 284 1149.12 284L1157.06 293Z",
    fill: "#FFB27D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_95",
    d: "M1106.94 300.6C1106.94 296 1111.25 292.4 1116.46 292.4C1121.68 292.4 1125.76 296 1125.76 300.6C1125.76 305.2 1121.68 308.8 1116.46 308.8C1111.25 308.8 1106.94 305.2 1106.94 300.6Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_96",
    d: "M1361.64 242.2C1361.49 243.4 1361.34 244.467 1361.19 245.4C1357.33 257.8 1309.7 267.2 1304.26 262.8C1303.35 261.867 1302.37 260.667 1301.31 259.2C1287.7 239.4 1270.46 167.8 1277.27 172C1277.27 172 1289.97 168.4 1300.4 167.6L1302.22 167.4C1305.62 167.2 1308.57 167.4 1310.61 168.2C1319.45 171 1326.48 191.4 1326.48 191.4C1326.48 191.4 1333.74 190.6 1340.32 191.2C1341.08 191.333 1341.91 191.467 1342.81 191.6C1344.63 192 1346.44 192.6 1347.8 193.4C1353.47 196.8 1362.55 228.8 1361.64 242.2Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_97",
    d: "M1275.91 174.8C1260.71 162 1233.27 167.8 1233.27 167.8L1239.39 162C1266.83 157.2 1283.16 171 1283.16 171L1275.91 174.8Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_98",
    d: "M1235.54 236.6C1235.54 236.6 1252.09 262.2 1296.77 249.6L1301.31 259.2C1301.31 259.2 1248.24 272.4 1230.09 246.6L1235.54 236.6Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_99",
    d: "M1272.73 190C1281.12 202 1240.53 260.4 1233.72 267.2C1209.91 291 1173.62 287.8 1173.62 287.8C1166.13 285.2 1162.5 275.2 1162.5 275.2C1172.26 268.8 1195.16 251 1201.29 241.8C1216.26 219 1223.06 187.8 1226.01 181C1230.09 171.8 1241.43 172.8 1241.43 172.8C1241.43 172.8 1264.34 178 1272.73 190V190Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_100",
    d: "M1302.22 167.4C1300.63 168.8 1297.45 172.6 1298.36 179.4C1299.95 188.8 1303.35 195.6 1303.35 195.6L1302.22 196.2C1302.22 196 1298.59 189.2 1297.23 179.6C1296.32 173.4 1298.59 169.6 1300.4 167.6L1302.22 167.4Z",
    fill: "#ED7D2B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_101",
    d: "M1348.48 242.6L1347.12 243C1346.67 241.4 1333.97 205.4 1334.88 198.6C1335.33 194.4 1338.28 192.4 1340.32 191.2C1341.08 191.333 1341.91 191.467 1342.81 191.6C1341.23 192 1336.69 193.6 1336.01 198.8C1335.33 205.2 1348.26 242.2 1348.48 242.6Z",
    fill: "#ED7D2B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_102",
    d: "M1317.41 220.6L1327.84 249.6C1318.32 255.2 1302.67 254.8 1302.67 254.8L1291.56 226.6C1308.79 226.4 1317.41 220.6 1317.41 220.6Z",
    fill: "#ED7D2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_103",
    d: "M1361.64 242.2C1361.49 243.4 1361.34 244.467 1361.18 245.4C1357.33 257.8 1309.7 267.2 1304.26 262.8C1303.35 261.867 1302.37 260.667 1301.31 259.2C1301.76 259.2 1328.75 258.4 1361.64 242.2V242.2Z",
    fill: "#ED7D2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_104",
    d: "M1317.41 220.6L1320.36 228.6L1309.7 235.8L1294.73 235L1291.56 226.6C1300.63 223.6 1317.41 220.6 1317.41 220.6Z",
    fill: "#EF873A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_105",
    d: "M1307.43 233.4C1307.43 233 1307.89 232.6 1308.34 232.6C1309.02 232.6 1309.25 233 1309.25 233.4C1309.25 233.8 1309.02 234.2 1308.34 234.2C1307.89 234.2 1307.43 233.8 1307.43 233.4Z",
    fill: "#131375"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_106",
    d: "M883.083 254.2C809.825 171.6 728.402 168.8 727.495 168.8V167C728.402 167 810.732 169.8 884.67 253L883.083 254.2Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_107",
    d: "M717.969 167.8C717.969 163.6 721.825 160.2 726.815 160.2C731.577 160.2 735.433 163.6 735.433 167.8C735.433 172 731.577 175.6 726.815 175.6C721.825 175.6 717.969 172 717.969 167.8Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_108",
    d: "M875.144 252.8C875.144 248.6 879 245.2 883.763 245.2C888.526 245.2 892.608 248.6 892.608 252.8C892.608 257 888.526 260.4 883.763 260.4C879 260.4 875.144 257 875.144 252.8Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_109",
    d: "M904.856 152L903.268 150.6C903.722 150.2 958.155 95.3998 1077.91 96.7998V98.5999C959.062 97.1999 905.536 151.4 904.856 152Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_110",
    d: "M898.052 157.8C894.423 155.2 893.742 150.4 896.918 147C899.866 143.8 905.309 143.2 908.938 145.8C912.794 148.6 913.474 153.4 910.299 156.6C907.351 160 901.907 160.4 898.052 157.8V157.8Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_111",
    d: "M1071.78 103.2C1067.93 100.6 1067.47 95.7999 1070.42 92.3999C1073.37 89.1999 1078.81 88.5998 1082.67 91.1998C1086.3 93.9998 1086.98 98.7999 1084.03 102C1080.86 105.4 1075.41 105.8 1071.78 103.2Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_112",
    d: "M1459.39 151.6L1457.58 150.2C1458.26 149.6 1519.72 88.2002 1663.74 96.4002L1663.52 98.6001C1520.86 90.4001 1460.07 151 1459.39 151.6V151.6Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_113",
    d: "M1451.91 158.4C1447.14 155 1446.24 149.2 1449.41 145.6C1452.81 141.8 1459.39 141.6 1464.15 144.8C1468.69 148.2 1469.82 153.8 1466.42 157.6C1463.02 161.4 1456.44 161.6 1451.91 158.4Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_114",
    d: "M1656.48 103.6C1651.95 100.2 1650.81 94.6001 1654.22 90.8001C1657.62 87.0001 1664.2 86.8001 1668.96 90.0001C1673.49 93.4001 1674.63 99.2001 1671.23 102.8C1667.82 106.6 1661.25 106.8 1656.48 103.6Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_115",
    d: "M1130.07 414.6C1046.84 414.6 959.062 401.6 887.845 387.6C758.794 362 655.145 327 654.01 326.6L654.918 324.8C655.825 325.2 759.474 360.2 888.299 385.8C1007.37 409.4 1172.48 429.4 1284.98 391.6C1397.7 353.6 1517.23 359.2 1597.74 370.4C1684.61 382.6 1745.85 404.2 1746.53 404.4L1745.62 406.2C1745.16 405.8 1684.15 384.4 1597.29 372.2C1517.23 361 1398.15 355.6 1285.66 393.4C1240.3 408.6 1186.09 414.6 1130.07 414.6V414.6Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_116",
    d: "M1115.1 600.4C1097.19 600.4 1077.23 597.6 1057.27 589.6L1057.95 587.8C1118.05 612.2 1178.38 587.4 1178.84 587.2L1179.74 588.8C1179.52 589 1151.62 600.4 1115.1 600.4Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_117",
    d: "M1184.96 594C1181.1 596.6 1175.66 596.2 1172.71 592.8C1169.54 589.6 1170.22 584.6 1173.85 582C1177.7 579.4 1183.14 579.8 1186.09 583.2C1189.27 586.4 1188.59 591.4 1184.96 594Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_118",
    d: "M1063.17 594.6C1059.31 597.2 1053.87 596.8 1050.92 593.4C1047.74 590.2 1048.42 585.4 1052.05 582.8C1055.91 580 1061.35 580.6 1064.3 583.8C1067.47 587.2 1066.79 592 1063.17 594.6Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_119",
    d: "M1402.46 600.4C1384.55 600.4 1364.59 597.6 1344.63 589.6L1345.31 587.8C1405.41 612.2 1465.74 587.4 1466.42 587.2L1467.33 588.8C1466.88 589 1439.21 600.4 1402.46 600.4V600.4Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_120",
    d: "M1472.32 594C1468.46 596.6 1463.02 596.2 1460.07 592.8C1456.9 589.6 1457.58 584.6 1461.21 582C1465.06 579.4 1470.51 579.8 1473.45 583.2C1476.63 586.4 1475.95 591.4 1472.32 594Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_121",
    d: "M1350.53 594.6C1346.67 597.2 1341.23 596.8 1338.28 593.4C1335.1 590.2 1335.78 585.4 1339.41 582.8C1343.27 580 1348.71 580.6 1351.66 583.8C1354.83 587.2 1354.15 592 1350.53 594.6Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_145",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_122",
    d: "M1781 317.8V580.4L1674.63 568.2C1674.63 568.2 1665.1 512.8 1710.46 495.2C1752.42 479 1724.07 336.6 1781 317.8V317.8Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lefttop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lefttopdot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_124",
    d: "M486 510.958C486 520.899 477.941 528.958 468 528.958V528.958C458.059 528.958 450 520.899 450 510.958V508.263C450 498.322 458.059 490.263 468 490.263V490.263C477.941 490.263 486 498.322 486 508.263V510.958Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_125",
    d: "M486 419.595C486 429.536 477.941 437.595 468 437.595V437.595C458.059 437.595 450 429.536 450 419.595V416.9C450 406.959 458.059 398.9 468 398.9V398.9C477.941 398.9 486 406.959 486 416.9V419.595Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_126",
    d: "M486 328.232C486 338.173 477.941 346.232 468 346.232V346.232C458.059 346.232 450 338.173 450 328.232V325.537C450 315.596 458.059 307.537 468 307.537V307.537C477.941 307.537 486 315.595 486 325.537V328.232Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_127",
    d: "M486 236.868C486 246.809 477.941 254.868 468 254.868V254.868C458.059 254.868 450 246.809 450 236.868V234.173C450 224.232 458.059 216.173 468 216.173V216.173C477.941 216.173 486 224.232 486 234.173V236.868Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_128",
    d: "M486 145.505C486 155.446 477.941 163.505 468 163.505V163.505C458.059 163.505 450 155.446 450 145.505V142.81C450 132.869 458.059 124.81 468 124.81V124.81C477.941 124.81 486 132.869 486 142.81V145.505Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_146",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_123",
    d: "M555.4 562C555.4 575.807 544.207 587 530.4 587H81C67.1929 587 56 575.807 56 562V75C56 61.1929 67.1929 50 81 50H530.4C544.207 50 555.4 61.1929 555.4 75V562Z",
    fill: "#DDE7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lefttopline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_129",
    d: "M418.6 498.539C418.6 503.11 414.895 506.816 410.324 506.816H100.276C95.7055 506.816 92 503.11 92 498.539V498.539C92 493.968 95.7055 490.263 100.276 490.263H410.324C414.895 490.263 418.6 493.968 418.6 498.539V498.539Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_130",
    d: "M364 498.539C364 503.11 360.294 506.816 355.724 506.816H222.276C217.705 506.816 214 503.11 214 498.539V498.539C214 493.968 217.705 490.263 222.276 490.263H355.724C360.295 490.263 364 493.968 364 498.539V498.539Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_131",
    d: "M418.6 407.176C418.6 411.747 414.895 415.453 410.324 415.453H100.276C95.7055 415.453 92 411.747 92 407.176V407.176C92 402.605 95.7055 398.9 100.276 398.9H410.324C414.895 398.9 418.6 402.605 418.6 407.176V407.176Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_132",
    d: "M239 407.176C239 411.747 235.295 415.453 230.724 415.453H143.076C138.506 415.453 134.8 411.747 134.8 407.176V407.176C134.8 402.605 138.506 398.9 143.076 398.9H230.724C235.295 398.9 239 402.605 239 407.176V407.176Z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_133",
    d: "M418.6 315.813C418.6 320.384 414.895 324.089 410.324 324.089H100.276C95.7055 324.089 92 320.384 92 315.813V315.813C92 311.242 95.7055 307.537 100.276 307.537H410.324C414.895 307.537 418.6 311.242 418.6 315.813V315.813Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_134",
    d: "M358 315.813C358 320.384 354.295 324.089 349.724 324.089H261.877C257.306 324.089 253.6 320.384 253.6 315.813V315.813C253.6 311.242 257.306 307.537 261.877 307.537H349.724C354.295 307.537 358 311.242 358 315.813V315.813Z",
    fill: "#7A96E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_135",
    d: "M418.6 224.45C418.6 229.021 414.895 232.726 410.324 232.726H100.276C95.7055 232.726 92 229.021 92 224.45V224.45C92 219.879 95.7055 216.173 100.276 216.173H410.324C414.895 216.173 418.6 219.879 418.6 224.45V224.45Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_136",
    d: "M293.4 224.45C293.4 229.021 289.695 232.726 285.124 232.726H143.076C138.506 232.726 134.8 229.021 134.8 224.45V224.45C134.8 219.879 138.506 216.173 143.076 216.173H285.124C289.695 216.173 293.4 219.879 293.4 224.45V224.45Z",
    fill: "#7A96E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_137",
    d: "M418.6 133.087C418.6 137.658 414.895 141.363 410.324 141.363H100.276C95.7055 141.363 92 137.658 92 133.087V133.087C92 128.516 95.7055 124.81 100.276 124.81H410.324C414.895 124.81 418.6 128.516 418.6 133.087V133.087Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_138",
    d: "M385.2 133.087C385.2 137.658 381.495 141.363 376.924 141.363H254.276C249.705 141.363 246 137.658 246 133.087V133.087C246 128.516 249.705 124.81 254.276 124.81H376.924C381.495 124.81 385.2 128.516 385.2 133.087V133.087Z",
    fill: "#F77D48"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "leftbottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_161",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_139",
    d: "M549.4 1109C549.4 1122.81 538.207 1134 524.4 1134H75C61.1929 1134 50 1122.81 50 1109V662C50 648.193 61.1929 637 75 637H524.4C538.207 637 549.4 648.193 549.4 662V1109Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leftbottomdot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_140",
    d: "M264.8 708.485C264.8 717.266 257.681 724.385 248.9 724.385V724.385C240.119 724.385 233 717.266 233 708.485V705.549C233 696.768 240.119 689.649 248.9 689.649V689.649C257.681 689.649 264.8 696.768 264.8 705.549V708.485Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_141",
    d: "M321.4 708.585C321.4 717.311 314.326 724.385 305.6 724.385V724.385C296.874 724.385 289.8 717.311 289.8 708.585V705.449C289.8 696.723 296.874 689.649 305.6 689.649V689.649C314.326 689.649 321.4 696.723 321.4 705.449V708.585Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_142",
    d: "M508.8 700.572C508.8 704.071 505.964 706.908 502.465 706.908H349.735C346.236 706.908 343.4 704.071 343.4 700.572V700.572C343.4 697.074 346.236 694.237 349.735 694.237H502.465C505.964 694.237 508.8 697.074 508.8 700.572V700.572Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_143",
    d: "M185.8 705.881C185.8 697.695 195.344 693.219 201.638 698.454V698.454C206.666 702.637 206.171 710.502 200.659 714.022V714.022C194.229 718.128 185.8 713.51 185.8 705.881V705.881Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_144",
    d: "M264.8 774.679C264.8 783.46 257.681 790.579 248.9 790.579V790.579C240.119 790.579 233 783.46 233 774.679V771.962C233 763.18 240.119 756.062 248.9 756.062V756.062C257.681 756.062 264.8 763.18 264.8 771.962V774.679Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_145",
    d: "M321.4 774.779C321.4 783.505 314.326 790.579 305.6 790.579V790.579C296.874 790.579 289.8 783.505 289.8 774.779V771.862C289.8 763.136 296.874 756.062 305.6 756.062V756.062C314.326 756.062 321.4 763.136 321.4 771.862V774.779Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_146",
    d: "M508.8 766.876C508.8 770.435 505.915 773.32 502.355 773.32H349.845C346.285 773.32 343.4 770.435 343.4 766.876V766.876C343.4 763.316 346.285 760.431 349.845 760.431H502.355C505.915 760.431 508.8 763.316 508.8 766.876V766.876Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_147",
    d: "M185.8 772.293C185.8 764.107 195.344 759.632 201.638 764.867V764.867C206.666 769.049 206.171 776.915 200.659 780.435V780.435C194.229 784.541 185.8 779.922 185.8 772.293V772.293Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_148",
    d: "M264.8 841.091C264.8 849.872 257.681 856.991 248.9 856.991V856.991C240.119 856.991 233 849.872 233 841.091V838.155C233 829.374 240.119 822.255 248.9 822.255V822.255C257.681 822.255 264.8 829.374 264.8 838.155V841.091Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_149",
    d: "M321.4 841.191C321.4 849.917 314.326 856.991 305.6 856.991V856.991C296.874 856.991 289.8 849.917 289.8 841.191V838.055C289.8 829.329 296.874 822.255 305.6 822.255V822.255C314.326 822.255 321.4 829.329 321.4 838.055V841.191Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_150",
    d: "M508.8 833.178C508.8 836.677 505.964 839.514 502.465 839.514H349.735C346.236 839.514 343.4 836.677 343.4 833.178V833.178C343.4 829.679 346.236 826.843 349.735 826.843H502.465C505.964 826.843 508.8 829.679 508.8 833.178V833.178Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_151",
    d: "M185.8 838.487C185.8 830.301 195.344 825.825 201.638 831.06V831.06C206.666 835.243 206.171 843.108 200.659 846.628V846.628C194.229 850.735 185.8 846.116 185.8 838.487V838.487Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_152",
    d: "M264.8 907.285C264.8 916.066 257.681 923.185 248.9 923.185V923.185C240.119 923.185 233 916.066 233 907.285V904.568C233 895.787 240.119 888.668 248.9 888.668V888.668C257.681 888.668 264.8 895.787 264.8 904.568V907.285Z",
    fill: "#F77D48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_153",
    d: "M321.4 907.385C321.4 916.111 314.326 923.185 305.6 923.185V923.185C296.874 923.185 289.8 916.111 289.8 907.385V904.468C289.8 895.742 296.874 888.668 305.6 888.668V888.668C314.326 888.668 321.4 895.742 321.4 904.468V907.385Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_154",
    d: "M508.8 899.482C508.8 903.041 505.915 905.926 502.355 905.926H349.845C346.285 905.926 343.4 903.041 343.4 899.482V899.482C343.4 895.922 346.285 893.037 349.845 893.037H502.355C505.915 893.037 508.8 895.922 508.8 899.482V899.482Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_155",
    d: "M185.8 904.899C185.8 896.713 195.344 892.238 201.638 897.473V897.473C206.666 901.655 206.171 909.521 200.659 913.041V913.041C194.229 917.147 185.8 912.529 185.8 904.899V904.899Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_156",
    d: "M264.8 973.697C264.8 982.479 257.681 989.597 248.9 989.597V989.597C240.119 989.597 233 982.479 233 973.697V970.762C233 961.981 240.119 954.862 248.9 954.862V954.862C257.681 954.862 264.8 961.98 264.8 970.762V973.697Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_157",
    d: "M321.4 973.797C321.4 982.523 314.326 989.597 305.6 989.597V989.597C296.874 989.597 289.8 982.523 289.8 973.797V970.662C289.8 961.936 296.874 954.862 305.6 954.862V954.862C314.326 954.862 321.4 961.936 321.4 970.662V973.797Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_158",
    d: "M508.8 965.676C508.8 969.235 505.915 972.12 502.355 972.12H349.845C346.285 972.12 343.4 969.235 343.4 965.676V965.676C343.4 962.116 346.285 959.231 349.845 959.231H502.355C505.915 959.231 508.8 962.116 508.8 965.676V965.676Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_159",
    d: "M185.8 971.093C185.8 962.907 195.344 958.432 201.638 963.667V963.667C206.666 967.849 206.171 975.715 200.659 979.235V979.235C194.229 983.341 185.8 978.723 185.8 971.093V971.093Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_160",
    d: "M264.8 1039.89C264.8 1048.67 257.681 1055.79 248.9 1055.79V1055.79C240.119 1055.79 233 1048.67 233 1039.89V1036.96C233 1028.17 240.119 1021.06 248.9 1021.06V1021.06C257.681 1021.06 264.8 1028.17 264.8 1036.96V1039.89Z",
    fill: "#7A96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_161",
    d: "M321.4 1039.99C321.4 1048.72 314.326 1055.79 305.6 1055.79V1055.79C296.874 1055.79 289.8 1048.72 289.8 1039.99V1036.86C289.8 1028.13 296.874 1021.06 305.6 1021.06V1021.06C314.326 1021.06 321.4 1028.13 321.4 1036.86V1039.99Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_162",
    d: "M508.8 1032.09C508.8 1035.65 505.915 1038.53 502.355 1038.53H349.845C346.285 1038.53 343.4 1035.65 343.4 1032.09V1032.09C343.4 1028.53 346.285 1025.64 349.845 1025.64H502.355C505.915 1025.64 508.8 1028.53 508.8 1032.09V1032.09Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_163",
    d: "M185.8 1037.51C185.8 1029.32 195.344 1024.84 201.638 1030.08V1030.08C206.666 1034.26 206.171 1042.13 200.659 1045.65V1045.65C194.229 1049.75 185.8 1045.13 185.8 1037.51V1037.51Z",
    fill: "#9DB0F4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "leftbottomline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_186",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_164",
    d: "M92.5096 714.655C83.7001 710.974 84.19 698.605 92.8455 694.575C95.2494 693.456 97.9296 692.708 100.8 692.708C104.126 692.708 107.073 693.677 109.586 695.061C117.09 699.191 117.358 710.088 109.78 714.079C107.287 715.393 104.298 716.302 100.8 716.302C97.6531 716.302 94.8922 715.651 92.5096 714.655Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_165",
    d: "M92.8 704.505C92.8 699.917 96.2001 696.203 100.2 696.203C104.4 696.203 107.8 699.917 107.8 704.505C107.8 708.874 104.4 712.588 100.2 712.588C96.2001 712.588 92.8 708.874 92.8 704.505Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_166",
    d: "M95.6001 704.505C95.6001 701.665 97.8001 699.48 100.2 699.48C102.8 699.48 104.8 701.665 104.8 704.505C104.8 707.126 102.8 709.529 100.2 709.529C97.8001 709.529 95.6001 707.126 95.6001 704.505Z",
    fill: "#DDE7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_190",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_167",
    d: "M92.5096 780.849C83.7001 777.168 84.19 764.799 92.8455 760.769C95.2494 759.65 97.9296 758.902 100.8 758.902C104.126 758.902 107.073 759.871 109.586 761.255C117.09 765.385 117.358 776.281 109.78 780.273C107.287 781.586 104.298 782.495 100.8 782.495C97.6531 782.495 94.8922 781.845 92.5096 780.849Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_168",
    d: "M92.8 770.699C92.8 766.329 96.2001 762.615 100.2 762.615C104.4 762.615 107.8 766.329 107.8 770.699C107.8 775.286 104.4 779 100.2 779C96.2001 779 92.8 775.286 92.8 770.699Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_169",
    d: "M95.6001 770.699C95.6001 768.077 97.8001 765.674 100.2 765.674C102.8 765.674 104.8 768.077 104.8 770.699C104.8 773.539 102.8 775.723 100.2 775.723C97.8001 775.723 95.6001 773.539 95.6001 770.699Z",
    fill: "#DDE7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_194",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_170",
    d: "M92.5095 847.261C83.7001 843.58 84.19 831.211 92.8456 827.181C95.2494 826.062 97.9296 825.314 100.8 825.314C104.126 825.314 107.073 826.284 109.586 827.667C117.09 831.797 117.358 842.694 109.78 846.685C107.287 847.999 104.298 848.908 100.8 848.908C97.653 848.908 94.8921 848.257 92.5095 847.261Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_171",
    d: "M92.8 837.111C92.8 832.523 96.2001 828.809 100.2 828.809C104.4 828.809 107.8 832.523 107.8 837.111C107.8 841.48 104.4 845.194 100.2 845.194C96.2001 845.194 92.8 841.48 92.8 837.111Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_172",
    d: "M95.6001 837.111C95.6001 834.271 97.8001 832.086 100.2 832.086C102.8 832.086 104.8 834.271 104.8 837.111C104.8 839.732 102.8 842.135 100.2 842.135C97.8001 842.135 95.6001 839.732 95.6001 837.111Z",
    fill: "#DDE7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_198",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_173",
    d: "M92.5096 913.456C83.7001 909.774 84.19 897.405 92.8455 893.375C95.2494 892.256 97.9296 891.508 100.8 891.508C104.126 891.508 107.073 892.478 109.586 893.861C117.09 897.992 117.358 908.888 109.78 912.88C107.287 914.193 104.298 915.102 100.8 915.102C97.6531 915.102 94.8922 914.451 92.5096 913.456Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_174",
    d: "M92.8 903.305C92.8 898.936 96.2001 895.222 100.2 895.222C104.4 895.222 107.8 898.936 107.8 903.305C107.8 907.893 104.4 911.607 100.2 911.607C96.2001 911.607 92.8 907.893 92.8 903.305Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_175",
    d: "M95.6001 903.305C95.6001 900.683 97.8001 898.28 100.2 898.28C102.8 898.28 104.8 900.683 104.8 903.305C104.8 906.145 102.8 908.33 100.2 908.33C97.8001 908.33 95.6001 906.145 95.6001 903.305Z",
    fill: "#DDE7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_202",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_176",
    d: "M92.5095 979.867C83.7001 976.186 84.19 963.817 92.8456 959.787C95.2494 958.668 97.9296 957.92 100.8 957.92C104.126 957.92 107.073 958.89 109.586 960.273C117.09 964.403 117.358 975.3 109.78 979.291C107.287 980.605 104.298 981.514 100.8 981.514C97.653 981.514 94.8921 980.863 92.5095 979.867Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_177",
    d: "M92.8 969.717C92.8 965.129 96.2001 961.415 100.2 961.415C104.4 961.415 107.8 965.129 107.8 969.717C107.8 974.086 104.4 977.8 100.2 977.8C96.2001 977.8 92.8 974.086 92.8 969.717Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_178",
    d: "M95.6001 969.717C95.6001 966.877 97.8001 964.692 100.2 964.692C102.8 964.692 104.8 966.877 104.8 969.717C104.8 972.339 102.8 974.742 100.2 974.742C97.8001 974.742 95.6001 972.339 95.6001 969.717Z",
    fill: "#DDE7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_206",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_179",
    d: "M92.5095 1046.06C83.7001 1042.38 84.19 1030.01 92.8456 1025.98C95.2494 1024.86 97.9296 1024.11 100.8 1024.11C104.126 1024.11 107.073 1025.08 109.586 1026.47C117.09 1030.6 117.358 1041.49 109.78 1045.49C107.287 1046.8 104.298 1047.71 100.8 1047.71C97.653 1047.71 94.8921 1047.06 92.5095 1046.06Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_180",
    d: "M92.8 1035.91C92.8 1031.32 96.2001 1027.83 100.2 1027.83C104.4 1027.83 107.8 1031.32 107.8 1035.91C107.8 1040.5 104.4 1044.21 100.2 1044.21C96.2001 1044.21 92.8 1040.5 92.8 1035.91Z",
    fill: "#15156D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_181",
    d: "M95.6001 1035.91C95.6001 1033.29 97.8001 1030.89 100.2 1030.89C102.8 1030.89 104.8 1033.29 104.8 1035.91C104.8 1038.75 102.8 1040.94 100.2 1040.94C97.8001 1040.94 95.6001 1038.75 95.6001 1035.91Z",
    fill: "#DDE7FE"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "rightbottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_210",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_182",
    d: "M2331.6 1114C2331.6 1125.05 2322.65 1134 2311.6 1134H630C618.954 1134 610 1125.05 610 1114V657C610 645.954 618.954 637 630 637H2311.6C2322.65 637 2331.6 645.954 2331.6 657V1114Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rightbottomline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_183",
    d: "M1278 982.495C1278 972.833 1285.83 965 1295.49 965H2248.96C2258.62 965 2266.45 972.833 2266.45 982.495V982.495C2266.45 992.157 2258.62 999.99 2248.96 999.99H1295.49C1285.83 999.99 1278 992.157 1278 982.495V982.495Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_189",
    d: "M1673 983.495C1673 973.833 1680.83 966 1690.49 966H1947.68C1957.34 966 1965.18 973.833 1965.18 983.495V983.495C1965.18 993.157 1957.34 1000.99 1947.68 1000.99H1690.49C1680.83 1000.99 1673 993.157 1673 983.495V983.495Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_184",
    d: "M1277 1048.49C1277 1038.83 1284.83 1031 1294.49 1031H2247.51C2257.17 1031 2265 1038.83 2265 1048.49V1048.49C2265 1058.16 2257.17 1065.99 2247.51 1065.99H1294.49C1284.83 1065.99 1277 1058.16 1277 1048.49V1048.49Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_190",
    d: "M1594 1049.49C1594 1039.83 1601.83 1032 1611.49 1032H1868.68C1878.34 1032 1886.18 1039.83 1886.18 1049.49V1049.49C1886.18 1059.16 1878.34 1066.99 1868.68 1066.99H1611.49C1601.83 1066.99 1594 1059.16 1594 1049.49V1049.49Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_185",
    d: "M1126.93 921.999C1126.93 912.337 1134.76 904.504 1144.42 904.504H1842.18C1851.84 904.504 1859.67 912.337 1859.67 921.999V921.999C1859.67 931.661 1851.84 939.494 1842.18 939.494H1144.42C1134.76 939.494 1126.93 931.661 1126.93 921.999V921.999Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_186",
    d: "M1615.7 921.999C1615.7 912.337 1623.53 904.504 1633.2 904.504H2247.5C2257.17 904.504 2265 912.337 2265 921.999V921.999C2265 931.661 2257.17 939.494 2247.5 939.494H1633.2C1623.53 939.494 1615.7 931.661 1615.7 921.999V921.999Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group 555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_187",
    d: "M1277 851.5C1277 841.835 1284.84 834 1294.5 834H2247.5C2257.16 834 2265 841.835 2265 851.5V851.5C2265 861.165 2257.16 869 2247.5 869H1294.5C1284.83 869 1277 861.165 1277 851.5V851.5Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_188",
    d: "M1594.41 851.342C1594.41 841.679 1602.25 833.847 1611.91 833.847H1869.1C1878.76 833.847 1886.59 841.679 1886.59 851.342V851.342C1886.59 861.004 1878.76 868.837 1869.1 868.837H1611.91C1602.25 868.837 1594.41 861.004 1594.41 851.342V851.342Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_191",
    d: "M689 710.5C689 700.835 696.835 693 706.5 693H2247.5C2257.16 693 2265 700.835 2265 710.5V710.5C2265 720.165 2257.16 728 2247.5 728H706.5C696.835 728 689 720.165 689 710.5V710.5Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_192",
    d: "M1555.16 710.027C1555.16 700.365 1562.99 692.532 1572.66 692.532H1872.89C1882.55 692.532 1890.38 700.365 1890.38 710.027V710.027C1890.38 719.69 1882.55 727.522 1872.89 727.522H1572.66C1562.99 727.522 1555.16 719.69 1555.16 710.027V710.027Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_193",
    d: "M688.556 780.685C688.556 771.023 696.389 763.19 706.051 763.19H2247.51C2257.17 763.19 2265 771.023 2265 780.685V780.685C2265 790.347 2257.17 798.18 2247.51 798.18H706.051C696.389 798.18 688.556 790.347 688.556 780.685V780.685Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_194",
    d: "M1854.72 780.685C1854.72 771.023 1862.55 763.19 1872.22 763.19H2186.15C2195.82 763.19 2203.65 771.023 2203.65 780.685V780.685C2203.65 790.347 2195.82 798.18 2186.15 798.18H1872.22C1862.55 798.18 1854.72 790.347 1854.72 780.685V780.685Z",
    fill: "#7A96E5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "righttop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_214",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_196",
    d: "M2331 594.2C2331 605.246 2322.05 614.2 2311 614.2H1856C1844.95 614.2 1836 605.246 1836 594.2V72C1836 60.9543 1844.95 52 1856 52H2311C2322.05 52 2331 60.9543 2331 72V594.2Z",
    fill: "#DDE7FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "toprightline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_197",
    d: "M2137.8 100.5C2137.8 102.433 2136.23 104 2134.3 104H1899.5C1897.57 104 1896 102.433 1896 100.5V100.5C1896 98.567 1897.57 97 1899.5 97H2134.3C2136.23 97 2137.8 98.567 2137.8 100.5V100.5Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_198",
    d: "M2083 117.6C2083 119.478 2081.48 121 2079.6 121H1899.4C1897.52 121 1896 119.478 1896 117.6V117.6C1896 115.722 1897.52 114.2 1899.4 114.2H2079.6C2081.48 114.2 2083 115.722 2083 117.6V117.6Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_199",
    d: "M2137.8 176.7C2137.8 178.633 2136.23 180.2 2134.3 180.2H1899.5C1897.57 180.2 1896 178.633 1896 176.7V176.7C1896 174.767 1897.57 173.2 1899.5 173.2H2134.3C2136.23 173.2 2137.8 174.767 2137.8 176.7V176.7Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_200",
    d: "M2083 193.9C2083 195.833 2081.43 197.4 2079.5 197.4H1899.5C1897.57 197.4 1896 195.833 1896 193.9V193.9C1896 191.967 1897.57 190.4 1899.5 190.4H2079.5C2081.43 190.4 2083 191.967 2083 193.9V193.9Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_201",
    d: "M2137.8 253C2137.8 254.878 2136.28 256.4 2134.4 256.4H1899.4C1897.52 256.4 1896 254.878 1896 253V253C1896 251.122 1897.52 249.6 1899.4 249.6H2134.4C2136.28 249.6 2137.8 251.122 2137.8 253V253Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_202",
    d: "M2083 270.1C2083 272.033 2081.43 273.6 2079.5 273.6H1899.5C1897.57 273.6 1896 272.033 1896 270.1V270.1C1896 268.167 1897.57 266.6 1899.5 266.6H2079.5C2081.43 266.6 2083 268.167 2083 270.1V270.1Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_203",
    d: "M2137.8 329.2C2137.8 331.078 2136.28 332.6 2134.4 332.6H1899.4C1897.52 332.6 1896 331.078 1896 329.2V329.2C1896 327.322 1897.52 325.8 1899.4 325.8H2134.4C2136.28 325.8 2137.8 327.322 2137.8 329.2V329.2Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_204",
    d: "M2083 346.4C2083 348.278 2081.48 349.8 2079.6 349.8H1899.4C1897.52 349.8 1896 348.278 1896 346.4V346.4C1896 344.522 1897.52 343 1899.4 343H2079.6C2081.48 343 2083 344.522 2083 346.4V346.4Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_205",
    d: "M2137.8 405.5C2137.8 407.433 2136.23 409 2134.3 409H1899.5C1897.57 409 1896 407.433 1896 405.5V405.5C1896 403.567 1897.57 402 1899.5 402H2134.3C2136.23 402 2137.8 403.567 2137.8 405.5V405.5Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_206",
    d: "M2083 422.7C2083 424.633 2081.43 426.2 2079.5 426.2H1899.5C1897.57 426.2 1896 424.633 1896 422.7V422.7C1896 420.767 1897.57 419.2 1899.5 419.2H2079.5C2081.43 419.2 2083 420.767 2083 422.7V422.7Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_207",
    d: "M2137.8 481.8C2137.8 483.678 2136.28 485.2 2134.4 485.2H1899.4C1897.52 485.2 1896 483.678 1896 481.8V481.8C1896 479.922 1897.52 478.4 1899.4 478.4H2134.4C2136.28 478.4 2137.8 479.922 2137.8 481.8V481.8Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_208",
    d: "M2083 498.9C2083 500.833 2081.43 502.4 2079.5 502.4H1899.5C1897.57 502.4 1896 500.833 1896 498.9V498.9C1896 496.967 1897.57 495.4 1899.5 495.4H2079.5C2081.43 495.4 2083 496.967 2083 498.9V498.9Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_209",
    d: "M2137.8 558C2137.8 559.878 2136.28 561.4 2134.4 561.4H1899.4C1897.52 561.4 1896 559.878 1896 558V558C1896 556.122 1897.52 554.6 1899.4 554.6H2134.4C2136.28 554.6 2137.8 556.122 2137.8 558V558Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_210",
    d: "M2083 575.2C2083 577.078 2081.48 578.6 2079.6 578.6H1899.4C1897.52 578.6 1896 577.078 1896 575.2V575.2C1896 573.322 1897.52 571.8 1899.4 571.8H2079.6C2081.48 571.8 2083 573.322 2083 575.2V575.2Z",
    fill: "#9DB0F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_211",
    d: "M2278 107.7C2278 111.29 2275.09 114.2 2271.5 114.2V114.2C2267.91 114.2 2265 111.29 2265 107.7V107.5C2265 103.91 2267.91 101 2271.5 101V101C2275.09 101 2278 103.91 2278 107.5V107.7Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_212",
    d: "M2278 183.9C2278 187.49 2275.09 190.4 2271.5 190.4V190.4C2267.91 190.4 2265 187.49 2265 183.9V183.7C2265 180.11 2267.91 177.2 2271.5 177.2V177.2C2275.09 177.2 2278 180.11 2278 183.7V183.9Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_213",
    d: "M2278 260.1C2278 263.69 2275.09 266.6 2271.5 266.6V266.6C2267.91 266.6 2265 263.69 2265 260.1V260.1C2265 256.51 2267.91 253.6 2271.5 253.6V253.6C2275.09 253.6 2278 256.51 2278 260.1V260.1Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_214",
    d: "M2278 336.3C2278 339.89 2275.09 342.8 2271.5 342.8V342.8C2267.91 342.8 2265 339.89 2265 336.3V336.3C2265 332.71 2267.91 329.8 2271.5 329.8V329.8C2275.09 329.8 2278 332.71 2278 336.3V336.3Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_215",
    d: "M2278 412.7C2278 416.29 2275.09 419.2 2271.5 419.2V419.2C2267.91 419.2 2265 416.29 2265 412.7V412.5C2265 408.91 2267.91 406 2271.5 406V406C2275.09 406 2278 408.91 2278 412.5V412.7Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_216",
    d: "M2278 481.9C2278 485.49 2275.09 488.4 2271.5 488.4V488.4C2267.91 488.4 2265 485.49 2265 481.9V481.7C2265 478.11 2267.91 475.2 2271.5 475.2V475.2C2275.09 475.2 2278 478.11 2278 481.7V481.9Z",
    fill: "#9DB0F4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_217",
    d: "M2278 565.1C2278 568.69 2275.09 571.6 2271.5 571.6V571.6C2267.91 571.6 2265 568.69 2265 565.1V565.1C2265 561.51 2267.91 558.6 2271.5 558.6V558.6C2275.09 558.6 2278 561.51 2278 565.1V565.1Z",
    fill: "#9DB0F4"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_543"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1171H2396V1347.31C2396 1402.54 2351.23 1447.31 2296 1447.31H100C44.7716 1447.31 0 1402.54 0 1347.31V1171Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgEditor);
export default __webpack_public_path__ + "static/media/svg-editor.e145370b.svg";
export { ForwardRef as ReactComponent };